<!-- Modificada por IAL | 2026-04-10 | Powered by ianossolutions.ai -->
<nav class="navbar">
  <a href="" class="sidebar-toggler" (click)="toggleSidebar($event)">
    <i class="feather icon-menu"></i>
  </a>
  <div class="navbar-content">
    <!-- <form class="search-form">
      <div class="input-group">
        <div class="input-group-text">
          <i class="feather icon-search"></i>
        </div>
        <input type="text" class="form-control" id="navbarForm" placeholder="Search here...">
      </div>
    </form> -->
      <!-- <div class="d-flex align-items-center me-3">
    <img 
      class="wd-100 ht-30"
      [src]="'assets/images/Logo_IanOS.png'"
      alt="logo"
    >
  </div> -->
    <div *ngIf="user && user.is_admin_commerce">
      <label style="margin: 15px 0px;">
        <h3>
          {{'NAVBAR.branch' | translate }}: {{adminCommerceData.home_address}}
        </h3>
      </label>
    </div>
    <ul class="navbar-nav">
      <!-- <li class="nav-item">
        <div id="google_translate_element" class="google nav-link form-select"></div>
      </li> -->
      <li class="nav-item nav-brand-logo">
        <img [src]="logo" alt="brand" class="navbar-brand-logo">
      </li>
      <li class="nav-item" ngbDropdown>
        <a class="nav-link" ngbDropdownToggle id="languageDropdown" role="button">
          <ng-container *ngIf="languageSelected === 'en'">
            <img src="assets/images/flags/us.svg" class="wd-20 me-1" title="us" alt="us">
            <span class="fw-bold ms-1 me-1 d-none d-md-inline-block">{{'NAVBAR.language.english' | translate }}</span>
          </ng-container>
          <ng-container *ngIf="languageSelected === 'es'">
            <img src="assets/images/flags/es.svg" class="wd-20 me-1" title="es" alt="es">
            <span class="fw-bold ms-1 me-1 d-none d-md-inline-block">{{'NAVBAR.language.spanish' | translate }}</span>
          </ng-container>
        </a>
        <div ngbDropdownMenu aria-labelledby="languageDropdown">
          <a (click)="setLanguage('en')" ngbDropdownItem class="py-2"> <img src="assets/images/flags/us.svg"
              class="wd-20 me-1" title="us" alt="us"> <span class="ms-1"> {{'NAVBAR.language.english' | translate }}
            </span></a>
          <a (click)="setLanguage('es')" ngbDropdownItem class="py-2"> <img src="assets/images/flags/es.svg"
              class="wd-20 me-1" title="es" alt="es"> <span class="ms-1"> {{'NAVBAR.language.spanish' | translate }}
            </span></a>
          <!--<a ngbDropdownItem class="py-2"> <img src="assets/images/flags/fr.svg" class="wd-20 me-1" title="fr" alt="fr"> <span class="ms-1"> French </span></a>
          <a ngbDropdownItem class="py-2"> <img src="assets/images/flags/de.svg" class="wd-20 me-1" title="de" alt="de"> <span class="ms-1"> German </span></a>
          <a ngbDropdownItem class="py-2"> <img src="assets/images/flags/pt.svg" class="wd-20 me-1" title="pt" alt="pt"> <span class="ms-1"> Portuguese </span></a>-->
        </div>
      </li>
      <!--<li class="nav-item nav-apps" ngbDropdown>
        <a class="nav-link" ngbDropdownToggle id="appsDropdown">
          <i class="link-icon feather icon-grid"></i>
        </a>
        <div ngbDropdownMenu class="px-0" aria-labelledby="appsDropdown">
          <div class="px-3 py-2 d-flex align-items-center justify-content-between border-bottom">
            <p class="mb-0 fw-bold">Web Apps</p>
            &lt;!&ndash;<a href="javascript:;" class="text-muted">Edit</a>&ndash;&gt;
          </div>
          <div class="row g-0 p-1">
            &lt;!&ndash;<div class="col-3 text-center">
              <a routerLink="/apps/chat" class="dropdown-item d-flex flex-column align-items-center justify-content-center wd-70 ht-70"><i class="feather icon-message-square icon-lg mb-1"></i><p class="tx-12">Chat</p></a>
            </div>&ndash;&gt;
           &lt;!&ndash; <div class="col text-center">
              <a routerLink="/apps/calendar" class="dropdown-item d-flex flex-column align-items-center justify-content-center wd-70 ht-70"><i class="feather icon-calendar icon-lg mb-1"></i><p class="tx-12">Holidays</p></a>
            </div>&ndash;&gt;
            &lt;!&ndash;<div class="col-3 text-center">
              <a routerLink="/apps/email/inbox" class="dropdown-item d-flex flex-column align-items-center justify-content-center wd-70 ht-70"><i class="feather icon-mail icon-lg mb-1"></i><p class="tx-12">Email</p></a>
            </div>&ndash;&gt;
            <div class="col-6 text-center">
              <a routerLink="/general/profile" class="dropdown-item d-flex flex-column align-items-center justify-content-center wd-70 ht-70"><i class="feather icon-instagram icon-lg mb-1"></i><p class="tx-12">Profile</p></a>
            </div>
          </div>
          &lt;!&ndash;<div class="px-3 py-2 d-flex align-items-center justify-content-center border-top">
            <a href="" (click)="false">View all</a>
          </div>&ndash;&gt;
        </div>
      </li>-->
      <!--<li class="nav-item nav-messages" ngbDropdown>
        <a class="nav-link" ngbDropdownToggle id="messageDropdown">
          <i class="link-icon feather icon-mail"></i>
        </a>
        <div ngbDropdownMenu class="px-0" aria-labelledby="messageDropdown">
          <div class="px-3 py-2 d-flex align-items-center justify-content-between border-bottom">
            <p>9 New Messages</p>
            <a href="" (click)="false" class="text-muted">Clear all</a>
          </div>
          <div class="p-1">
            <a href="" (click)="false" class="dropdown-item d-flex align-items-center py-2">
              <div class="me-3">
                <img class="wd-30 ht-30 rounded-circle" src="https://via.placeholder.com/30x30" alt="user">
              </div>
              <div class="d-flex justify-content-between flex-grow-1">
                <div class="me-4">
                  <p>Leonardo Payne</p>
                  <p class="tx-12 text-muted">Project status</p>
                </div>
                <p class="tx-12 text-muted">2 min ago</p>
              </div>
            </a>
            <a href="" (click)="false" class="dropdown-item d-flex align-items-center py-2">
              <div class="me-3">
                <img class="wd-30 ht-30 rounded-circle" src="https://via.placeholder.com/30x30" alt="user">
              </div>
              <div class="d-flex justify-content-between flex-grow-1">
                <div class="me-4">
                  <p>Carl Henson</p>
                  <p class="tx-12 text-muted">Client meeting</p>
                </div>
                <p class="tx-12 text-muted">30 min ago</p>
              </div>
            </a>
            <a href="" (click)="false" class="dropdown-item d-flex align-items-center py-2">
              <div class="me-3">
                <img class="wd-30 ht-30 rounded-circle" src="https://via.placeholder.com/30x30" alt="user">
              </div>
              <div class="d-flex justify-content-between flex-grow-1">
                <div class="me-4">
                  <p>Jensen Combs</p>
                  <p class="tx-12 text-muted">Project updates</p>
                </div>
                <p class="tx-12 text-muted">1 hrs ago</p>
              </div>
            </a>
            <a href="" (click)="false" class="dropdown-item d-flex align-items-center py-2">
              <div class="me-3">
                <img class="wd-30 ht-30 rounded-circle" src="https://via.placeholder.com/30x30" alt="user">
              </div>
              <div class="d-flex justify-content-between flex-grow-1">
                <div class="me-4">
                  <p>Amiah Burton</p>
                  <p class="tx-12 text-muted">Project deatline</p>
                </div>
                <p class="tx-12 text-muted">2 hrs ago</p>
              </div>
            </a>
            <a href="" (click)="false" class="dropdown-item d-flex align-items-center py-2">
              <div class="me-3">
                <img class="wd-30 ht-30 rounded-circle" src="https://via.placeholder.com/30x30" alt="user">
              </div>
              <div class="d-flex justify-content-between flex-grow-1">
                <div class="me-4">
                  <p>Yaretzi Mayo</p>
                  <p class="tx-12 text-muted">New record</p>
                </div>
                <p class="tx-12 text-muted">5 hrs ago</p>
              </div>
            </a>
          </div>
          <div class="px-3 py-2 d-flex align-items-center justify-content-center border-top">
            <a href="" (click)="false">View all</a>
          </div>
        </div>
      </li>-->
      <li class="nav-item nav-tables" ngbDropdown>
        <a class="nav-link" ngbDropdownToggle id="tablesDropdown">
          <i class="link-icon feather icon-grid"></i>
        </a>
        <div ngbDropdownMenu class="px-0" aria-labelledby="tablesDropdown">
          <div class="px-3 py-2 d-flex align-items-center justify-content-between border-bottom">
            <p class="mb-0 fw-bold">Mesas</p>
          </div>
          <!-- Reservaciones -->
          <div class="px-3 pt-2 pb-1">
            <p class="tx-11 text-muted text-uppercase fw-bold mb-1">Reservaciones</p>
          </div>
          <div class="p-1">
            <ng-container *ngIf="tableReservationsList.length > 0; else noReservations">
              <a *ngFor="let item of tableReservationsList"
                [routerLink]="['/table-reservations/detail', item.uid]"
                class="dropdown-item d-flex align-items-center py-2">
                <div class="wd-30 ht-30 d-flex align-items-center justify-content-center bg-primary rounded-circle me-3 flex-shrink-0">
                  <i class="feather icon-calendar icon-sm text-white"></i>
                </div>
                <div class="flex-grow-1 me-2">
                  <p class="mb-0 fw-bold tx-13">{{ item.customer_name }}</p>
                  <p class="tx-11 text-muted mb-0">{{ item.reservation_status }}</p>
                </div>
              </a>
            </ng-container>
            <ng-template #noReservations>
              <p class="tx-12 text-muted px-2 mb-1">Sin reservaciones</p>
            </ng-template>
          </div>
          <!-- Mesas -->
          <div class="px-3 pt-2 pb-1 border-top">
            <p class="tx-11 text-muted text-uppercase fw-bold mb-1">Mesas</p>
          </div>
          <div class="p-1">
            <ng-container *ngIf="tables.length > 0; else noTables">
              <a *ngFor="let item of tables"
                class="dropdown-item d-flex align-items-center py-2">
                <div class="wd-30 ht-30 d-flex align-items-center justify-content-center bg-secondary rounded-circle me-3 flex-shrink-0">
                  <i class="feather icon-box icon-sm text-white"></i>
                </div>
                <div class="flex-grow-1 me-2">
                  <p class="mb-0 fw-bold tx-13">{{ item.table_name }}</p>
                  <p class="tx-11 text-muted mb-0">{{ item.area_name }} · {{ item.number_chairs }} sillas</p>
                </div>
              </a>
            </ng-container>
            <ng-template #noTables>
              <p class="tx-12 text-muted px-2 mb-1">Sin mesas registradas</p>
            </ng-template>
          </div>
          <div class="px-3 py-2 d-flex align-items-center justify-content-center border-top">
            <a [routerLink]="'/table-reservations'">Ver todo</a>
          </div>
        </div>
      </li>
      <li class="nav-item nav-notifications" ngbDropdown>
        <a class="nav-link" ngbDropdownToggle id="notificationDropdown">
          <i class="link-icon feather icon-bell"></i>
          <div class="indicator">
            <div class="circle"></div>
          </div>
        </a>
        <div ngbDropdownMenu class="px-0" aria-labelledby="notificationDropdown">
          <div class="px-3 py-2 d-flex align-items-center justify-content-between border-bottom">
            <p>{{ newOrders.length }} {{'NAVBAR.newOrders' | translate }}</p>
          </div>
          <div class="p-1">
            <a *ngFor="let order of newOrders" [href]="'/orders/detail/'+order.id"
              class="dropdown-item d-flex align-items-center py-2">
              <div class="wd-30 ht-30 d-flex align-items-center justify-content-center bg-primary rounded-circle me-3">
                <i class="feather icon-gift icon-sm text-white"></i>
              </div>
              <div class="flex-grow-1 me-2">
                <p>{{ order.who_receives }}</p>
                <p class="tx-12 text-muted">{{ currency + '' + order.total }}</p>
              </div>
            </a>
          </div>
          <div class="px-3 py-2 d-flex align-items-center justify-content-center border-top">
            <a [routerLink]="'/orders'">{{'NAVBAR.viewAll' | translate }}</a>
          </div>
        </div>
      </li>
      <li class="nav-item nav-profile" ngbDropdown *ngIf="user">
        <a class="nav-link" ngbDropdownToggle id="profileDropdown">
          <img #navProfileImg class="wd-30 ht-30 rounded-circle"
            [src]="user.photo || 'assets/images/user-circle.png'" alt="profile"
            (error)="navProfileImg.style.display='none'; navProfileFallback.style.display='flex'">
          <div #navProfileFallback class="wd-30 ht-30 rounded-circle bg-light align-items-center justify-content-center" style="display:none;">
            <i class="feather icon-user text-muted" style="font-size: 1rem;"></i>
          </div>
        </a>
        <div ngbDropdownMenu class="px-0" aria-labelledby="profileDropdown">
          <div class="d-flex flex-column align-items-center border-bottom px-5 py-3">
            <div class="mb-3">
              <img #dropProfileImg class="wd-80 ht-80 rounded-circle"
                [src]="user.photo || 'assets/images/user-circle.png'"
                [alt]="user.firstName + ' ' + user.lastName"
                (error)="dropProfileImg.style.display='none'; dropProfileFallback.style.display='flex'">
              <div #dropProfileFallback class="wd-80 ht-80 rounded-circle bg-light align-items-center justify-content-center" style="display:none;">
                <i class="feather icon-user text-muted" style="font-size: 2.5rem;"></i>
              </div>
            </div>
            <div class="text-center">
              <p class="tx-16 fw-bolder">{{ user.firstName + ' ' + user.lastName }}</p>
              <p class="tx-12 text-muted">{{ user.email }}</p>
            </div>
          </div>
          <ul class="list-unstyled p-1">
            <li class="dropdown-item py-2">
              <a routerLink="/general/profile" class="d-flex text-body ms-0">
                <i class="feather icon-user me-2 icon-md"></i>
                <span>{{'NAVBAR.profile' | translate }}</span>
              </a>
            </li>
            <!--<li class="dropdown-item py-2">
              <a href="" (click)="false" class="d-flex text-body ms-0">
                <i class="feather icon-edit me-2 icon-md"></i>
                <span>Edit Profile</span>
              </a>
            </li>-->
            <li class="dropdown-item py-2">
              <a href="" (click)="onLogout($event)" class="d-flex text-body ms-0">
                <i class="feather icon-log-out me-2 icon-md"></i>
                <span>{{'NAVBAR.logOut' | translate }}</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</nav>